import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { h } from 'preact';
export default (props) => {
    const { icon, hasAudio, i18n } = props;
    return (_jsxs("div", { className: "uppy-Audio-permissons", children: [_jsx("div", { className: "uppy-Audio-permissonsIcon", children: icon() }), _jsx("div", { className: "uppy-Audio-title", children: hasAudio ? i18n('allowAudioAccessTitle') : i18n('noAudioTitle') }), _jsx("p", { children: hasAudio
                    ? i18n('allowAudioAccessDescription')
                    : i18n('noAudioDescription') })] }));
};
